module.exports = __webpack_public_path__ + "6cb1fb17470ce37498e07b44d0a9e533.svg";